export default class NiveisCombustivelConstant {
    static NIVEIS = [
        {
            nivel: 'Baixo',
            valor: 270,
            icone: 'arrow_circle_down',
            classeIcone: 'text-[#CC0003]'
        },
        {
            nivel: '1/4',
            valor: 315,
            icone: '',
            classeIcone: 'rotate-90 ml-4'
        },
        {
            nivel: '1/2',
            valor: 360,
            icone: '',
            classeIcone: 'rotate-90 ml-4'
        },
        {
            nivel: '3/4',
            valor: 405,
            icone: '',
            classeIcone: 'rotate-90 ml-4'
        },
        {
            nivel: 'Alto',
            valor: 450,
            icone: 'arrow_circle_up',
            classeIcone: 'text-verde-sucesso'
        },
    ]
}
